//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { SendLoginEmailInputItem } from './SendLoginEmailInputItem';

export class SendStudentPortalLoginEmailInputItem extends SendLoginEmailInputItem {
    RecipientIDs: string[] = [];
    UseTemplateSubjectAndMessageBody: boolean = false;
    SubjectWithPlaceholders: string | null = null;
    BodyWithPlaceholders: string | null = null;

    constructor(initializer?: Partial<SendStudentPortalLoginEmailInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "SendStudentPortalLoginEmailInputItem";
}
